module.exports = __webpack_public_path__ + "img/horizontal_3_3_8017.d8981b26.png";